import Api from '@/services/api';
import qs from 'querystring';

export default {
  search_invoices(search, type, filters = [], hiddenFilter = '',page = 1, sortBy = 'date', sortDesc = false) {

    return Api().post('/invoices/search', qs.stringify({
      'search': encodeURIComponent(search),
      'type': type,
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
    }));
  },
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'date', sortDesc = false, fetchFacets = true) {

    return Api().post('/invoices/search', qs.stringify({
      'search': '',
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },

  commission(creancierID) {
    return Api().get('/invoices/commission?creancierID=' + creancierID);
  },
  confirm_commission(data) {
    return Api().post('/invoices/confirm-commission', 'creditors=' + JSON.stringify(data));
  },
  get(id) {
    return Api().get('/invoice/' + id);
  },
 
  chartAccounts(startDate = null, endDate = null, by = null) {
    return Api().post('/invoices/chartAccounts', qs.stringify({
      
        startDate: startDate,
        endDate: endDate,
        by: by
      
    }));
  },
  delete_invoice(data) {
    return Api().delete('/invoice/' + data.invoice_id );
  },
  avert_invoice(data) {
    return Api().get('/invoice/' + data.invoice_id + '/avert')
  },
  update_invoice(data) {
    return Api().post('/invoice/' + data.invoice_id , qs.stringify({ data: JSON.stringify(data.invoice) }));    
  },
  create_invoice(data) {
    return Api().post('/invoice', qs.stringify({ invoice: JSON.stringify(data.invoice), products: JSON.stringify(data.products) }));    
  },
  invoice(data) {
    return Api().get('/invoice/' + data.invoice_id );
  },
  payment(invoice_id, id) {
    return Api().get('/invoice/'+ invoice_id +'/payment/' + id );
  },
  savePayment(invoice_id, payment_id, payment) {
    return Api().post('/invoice/' + invoice_id + '/payment/' + payment_id, qs.stringify({ data: JSON.stringify(payment)}));
  },
  createPayment(invoice_id, payment) {
    return Api().post('/invoice/' + invoice_id + '/payment/new', qs.stringify({ data: JSON.stringify(payment)}));
  },
  deletePayment(invoice_id, payment_id) {
    return Api().delete('/invoice/' + invoice_id + '/payment/' + payment_id);
  }
}